export const defaultHomePlaylistQueryParams: BULLZ.CreatePlaylistRequest = {
    limit: 10,
    returnQueryCount: true,
    returnQueryPerformanceMetrics: true
};
